/* exported getThemeFile */

/**
 * Load a theme file.
 * @param {string} file The file path from the theme root
 * @param {bool|function} [child] If getting the file from the child theme
 * @param {function} [callback] Run a callback on success
 * @return {void}
 */
function getThemeFile(file, child, callback) {
    if (typeof child === "function") {
        callback = child;
        child = false;
    }

    var path = jQuery('script[src*="all.js"]').attr("src").split("/all.js")[0];
    if (child) {
        path = path.split('/').slice(0, -1).join('/')+'/';
    } else {
        path = path.split('/').slice(0, -2).join('/')+'/parent-build/';
    }
    path += file;

    jQuery.getScript(path, callback);
}
